<template>
  <nav id="fixed-header" v-if="allDates">
    <div class="row expanded align-middle collapse nav-row">
      <div class="xxlarge-5 small-4 columns hide-mq">
        <router-link v-bind:to="'/'" class="back-link"><span>Todas exposições</span></router-link>
      </div>
      <div class="xxlarge-2 small-4 xsmall-6 columns align-center text-center">
        <router-link v-bind:to="'/'">
          <svg class="main-logo" viewBox="0 0 222 76">
            <path class="colegio-das-artes" d="M12.5 4.5l.4.1c-.1.2-.1.4-.2.6 0 .2-.1.3-.2.5 0 .4.1.7.1 1v.9h-.5c-.1-.9-.4-1.6-.9-2.1-.5-.4-1.2-.6-2.1-.6-1.2 0-2.2.4-2.9 1.3s-1 2.1-1 3.6.4 2.7 1.1 3.6c.8.9 1.7 1.4 3 1.4.9 0 1.6-.2 2.1-.6.5-.4.9-1 1-1.7h.5c0 .2-.1.5-.1.7 0 .3-.1.5-.1.8 0 .2.1.3.1.4v.2c-.5.2-1 .4-1.7.6-.6.1-1.3.2-2 .2-1.9 0-3.5-.5-4.6-1.5S2.8 11.6 2.8 10c0-1.7.6-3 1.7-4.1S7.1 4.4 9 4.4c.7 0 1.3.1 2 .2s1.1.2 1.1.2h.3c0-.1.1-.2.1-.3zm16.6 5.3c0 1.6-.5 2.9-1.6 3.9s-2.4 1.6-4.1 1.6c-1.6 0-3-.5-4.1-1.6-1.1-1-1.6-2.4-1.6-3.9 0-1.6.5-2.9 1.6-3.9s2.4-1.6 4.1-1.6c1.6 0 3 .5 4.1 1.6 1 1.1 1.6 2.4 1.6 3.9zm-5.7 5c1 0 1.8-.5 2.4-1.4s.9-2.1.9-3.6-.3-2.7-.9-3.6-1.4-1.3-2.4-1.3-1.8.4-2.4 1.3c-.7.9-1 2.1-1 3.6s.3 2.7.9 3.6c.6 1 1.5 1.4 2.5 1.4zM33.6 4.5c.4 0 .8.1 1.2.1.4.1.8.1 1.3.2.4-.1.9-.2 1.3-.2.4-.1.8-.1 1.2-.1v.4c-.6 0-1 .2-1.2.6-.3.3-.4 1.1-.4 2.2v4.5c0 .9.1 1.5.3 1.7s.6.3 1.2.3c1.2 0 2-.1 2.4-.4s.7-.7.8-1.3h.5c0 .3-.1.6-.2.8 0 .4 0 .7-.2.9 0 .1.1.2.1.3v.2c0 .2-.1.3-.3.4-.2.1-.8.1-1.6.1h-.5c-.8 0-1.4 0-2-.1s-1.1-.1-1.6-.2c-.4.1-.9.2-1.2.2-.4.1-.7.1-1 .1v-.4c.6 0 1-.2 1.2-.6.2-.3.3-1.2.3-2.6V8.8v-.7-.3c0-1.2-.1-2-.3-2.4-.2-.3-.6-.5-1.1-.6l-.2-.3zm12.8 0c.4 0 .7.1 1.1.1.4 0 .7.1 1.1.2.5-.1 1.1-.2 1.8-.2.7-.1 1.4-.1 2.2-.1h.5c.4 0 .7 0 .8.1.1 0 .2.1.2.3 0 .1 0 .1-.1.2 0 .1-.1.2-.2.3.2.3.2.6.3.8v.7h-.4c0-.6-.2-1-.5-1.3-.3-.2-.9-.3-1.7-.3H50v4.1h1.4c.7 0 1.2-.1 1.4-.2.1-.2.2-.5.3-.9h.5c0 .2 0 .4-.1.6 0 .2-.1.5-.2.7.1.3.1.5.2.8 0 .2.1.4.1.6h-.5c0-.4-.2-.7-.4-.8s-.7-.2-1.5-.2h-1.4v2.2c0 1 .1 1.6.3 1.8s.7.3 1.5.3c.9 0 1.6-.2 2.1-.5s.7-.8.8-1.6h.5c0 .4-.1.8-.2 1.1-.1.3-.2.6-.3.8 0 .1.1.2.1.2v.2c0 .2-.1.3-.3.4-.2.1-.7.1-1.5.1h-.7c-.8 0-1.5 0-2.1-.1s-1.1-.1-1.6-.2c-.4.1-.9.2-1.2.2-.4.1-.7.1-1 .1v-.4c.6 0 1-.2 1.2-.6.2-.3.3-1.2.3-2.6V8.8v-.7-.3c0-1.2-.1-2-.3-2.4-.2-.3-.6-.5-1.1-.6v-.3h.1zm5.9-2.3L50 3.6h-.6l2-2.1c.2-.2.4-.4.5-.4.1-.1.2-.2.4-.2s.3.1.4.2.2.3.2.4c0 .1 0 .3-.1.4-.1.1-.3.2-.5.3zm18.1 12.2c-.7.3-1.4.5-2.1.7-.8.2-1.5.2-2.3.2-2 0-3.5-.5-4.6-1.5s-1.7-2.3-1.7-4 .6-3 1.7-4 2.6-1.5 4.5-1.5c.6 0 1.3.1 2 .2s1.1.2 1.1.2h.3c.1 0 .1-.1.2-.2l.4.1c-.1.2-.1.4-.2.6 0 .2-.1.3-.2.5 0 .3.1.6.1.9v1H69c-.1-.9-.4-1.6-.9-2.1s-1.2-.7-2.2-.7c-1.2 0-2.2.4-2.9 1.3s-1.1 2-1.1 3.5.4 2.8 1.2 3.7 1.9 1.4 3.2 1.4c.6 0 1-.1 1.2-.2.2-.1.3-.5.3-1.1v-1.1c0-.6-.1-1.1-.3-1.3-.2-.2-.6-.4-1.2-.4v-.4c.5 0 .9.1 1.3.1.4.1.8.1 1.2.2.3-.1.6-.1 1-.2.3-.1.7-.1 1.1-.1v.4c-.4.1-.7.3-.9.5-.2.3-.2.7-.2 1.4v.9c0 .2 0 .3.1.4.1.1.2.1.4.1l.1.5zm5-9.9c.3 0 .7.1 1.1.1s.9.1 1.3.2c.5-.1.9-.1 1.3-.2s.8-.1 1.1-.1v.3c-.6 0-.9.2-1.1.5s-.3 1.1-.3 2.3v4.2c0 1.2.1 2 .3 2.4.2.3.6.5 1.1.6v.4c-.3 0-.7-.1-1.1-.1s-.8-.1-1.3-.2c-.6.1-1 .2-1.4.2s-.7.1-1 .1v-.4c.6 0 .9-.2 1.1-.5s.3-1.1.3-2.3V7.8c0-1.2-.1-2-.3-2.4-.2-.3-.6-.5-1.1-.6v-.3zm20.9 5.3c0 1.6-.5 2.9-1.6 3.9s-2.4 1.6-4.1 1.6c-1.6 0-3-.5-4.1-1.6-1.1-1-1.6-2.4-1.6-3.9 0-1.6.5-2.9 1.6-3.9s2.4-1.6 4.1-1.6c1.6 0 3 .5 4.1 1.6s1.6 2.4 1.6 3.9zm-5.7 5c1 0 1.8-.5 2.4-1.4s.9-2.1.9-3.6-.3-2.7-.9-3.6-1.4-1.3-2.4-1.3-1.8.4-2.4 1.3-.9 2.1-.9 3.6.3 2.7.9 3.6c.6 1 1.4 1.4 2.4 1.4zm19.3.1c-.4.1-.9.1-1.3.2-.4 0-.8.1-1.1.1v-.4c.6 0 .9-.2 1.1-.5s.3-1.1.3-2.3V7.7c0-1.2-.1-2-.3-2.3-.2-.3-.6-.5-1.1-.5v-.3c.4 0 .7 0 1.1.1.4 0 .8.1 1.3.2.5-.1 1.1-.2 1.6-.3.5-.1 1-.1 1.4-.1 2 0 3.5.5 4.7 1.4 1.1 1 1.7 2.3 1.7 4s-.6 3-1.7 3.9-2.7 1.4-4.6 1.4c-.4 0-.9 0-1.3-.1-.5 0-1.1-.1-1.8-.2zm1-4v2.5c0 .4.1.6.1.7.1.2.3.4.5.5.3.1.7.1 1.2.1 1.3 0 2.3-.4 3.1-1.2.7-.8 1.1-2 1.1-3.4 0-1.6-.4-2.9-1.2-3.8-.7-.8-1.9-1.3-3.3-1.3h-.7c-.2 0-.4 0-.6.1 0 .4-.1.9-.1 1.5V10.9h-.1zM128 4.4h1.1l2.1 5.3c.1.3.3.8.5 1.3 1 2.5 1.8 3.8 2.5 3.8v.4c-.4 0-1.1-.1-2.1-.2h-.2c-.5.1-.9.1-1.3.2-.4 0-.7.1-1 .1v-.4c.3 0 .6-.1.8-.2.2-.1.2-.3.2-.5 0-.1-.1-.4-.2-.8s-.3-.9-.5-1.4l-.3-.8H125.9l-.3.7c-.2.5-.4 1-.5 1.5-.1.4-.2.7-.2.9s.1.4.2.5.4.2.7.2v.4c-.3 0-.5 0-.8-.1-.3 0-.6-.1-1-.2-.4.1-.7.1-1 .2-.3 0-.6.1-.9.1V15h.1c.8 0 1.8-1.3 2.8-4 .2-.5.4-.9.5-1.2l2.5-5.4zm0 2c-.3.7-.6 1.3-.8 2-.3.7-.5 1.4-.8 2.1h3.2c-.3-.8-.5-1.5-.8-2.1-.3-.7-.6-1.3-.8-2zm10.3 8.7c0-.2.1-.4.1-.6.1-.2.1-.4.2-.5-.1-.4-.1-.7-.1-.9v-.8-.2-.2h.5c0 .9.3 1.7.8 2.2s1.2.8 2 .8c.6 0 1.2-.2 1.5-.5.4-.3.6-.8.6-1.4 0-.5-.2-.9-.5-1.2s-1-.7-1.9-1.1c-1.2-.5-1.9-1-2.4-1.4-.4-.5-.6-1.1-.6-1.7 0-.9.3-1.6 1-2.2s1.5-.8 2.6-.8c.4 0 .8 0 1.3.1s.8.1.9.1c.1 0 .2 0 .2-.1.1 0 .1-.1.1-.2h.5c0 .2-.1.3-.1.5-.1.2-.1.3-.2.5 0 .2.1.5.1.7V7.3h-.5c0-.7-.3-1.3-.7-1.7-.4-.4-.9-.6-1.6-.6-.6 0-1.1.2-1.4.5-.4.3-.5.7-.5 1.2 0 .8.9 1.6 2.6 2.4h.1c1 .4 1.8.9 2.2 1.4s.6 1.1.6 1.8c0 .9-.4 1.7-1.1 2.3-.7.6-1.7.9-2.9.9-.5 0-1.1-.1-1.7-.3-.6-.2-.9-.3-1-.3s-.2 0-.2.1c-.1 0-.1.1-.1.2l-.4-.1zm23.4-10.7h1.1l2.1 5.3c.1.3.3.8.5 1.3 1 2.5 1.8 3.8 2.5 3.8v.4c-.4 0-1.1-.1-2.1-.2h-.2c-.5.1-.9.1-1.3.2-.4 0-.7.1-1 .1v-.4c.3 0 .6-.1.8-.2.2-.1.2-.3.2-.5 0-.1-.1-.4-.2-.8s-.3-.9-.5-1.4l-.3-.8H159.6l-.3.7c-.2.5-.4 1-.5 1.5-.1.4-.2.7-.2.9s.1.4.2.5c.1.1.4.2.7.2v.4c-.3 0-.5 0-.8-.1-.3 0-.6-.1-1-.2-.4.1-.7.1-1 .2-.3 0-.6.1-.9.1V15h.1c.8 0 1.8-1.3 2.8-4 .2-.5.4-.9.5-1.2l2.5-5.4zm0 2c-.3.7-.6 1.3-.8 2-.3.7-.5 1.4-.8 2.1h3.2c-.3-.8-.5-1.5-.8-2.1-.3-.7-.6-1.3-.8-2zm16.5 3.4c.9 1.9 1.7 3.2 2.3 3.9.6.7 1.3 1.1 1.9 1.1h.1v.4c-.2 0-.4 0-.5.1h-.4c-.7 0-1.2-.1-1.7-.2-.4-.1-.8-.3-1.1-.6-.5-.4-1-1.2-1.6-2.4-.2-.4-.4-.7-.5-.9-.2-.4-.7-.6-1.4-.7h-.5v1.4c0 1.3.1 2.1.3 2.4.2.3.6.5 1.1.5v.4c-.3 0-.7 0-1.1-.1-.4 0-.8-.1-1.3-.2-.6.1-1 .2-1.4.2s-.7.1-1 .1v-.4c.6 0 .9-.2 1.1-.5.2-.3.3-1.1.3-2.3V7.9c0-1.3-.1-2.1-.3-2.4s-.6-.5-1.2-.6v-.3c.4 0 .7 0 1.1.1.4 0 .7.1 1.1.2.5-.1.9-.2 1.4-.2s.9-.1 1.4-.1c1.3 0 2.2.2 2.9.7s1 1.1 1 2c0 .6-.2 1.1-.5 1.6-.4.4-.9.7-1.5.9zm-3.3.1c.2 0 .4 0 .6.1h.4c.7 0 1.2-.2 1.6-.6.4-.4.6-1 .6-1.7 0-.8-.2-1.5-.6-1.9-.4-.5-1-.7-1.8-.7h-.7V7.4l-.1 2.5zm12.3 5.3v-.4c.4 0 .7-.1 1-.2.2-.1.4-.2.5-.4s.2-.5.2-.8c0-.4.1-1.1.1-2.1V8.8 7 5.1h-1c-.9 0-1.5.1-1.9.4s-.6.8-.7 1.5h-.5c0-.3.1-.6.1-.9.1-.3.1-.6.2-.9 0-.2-.1-.4-.1-.5v-.6h.4v.2c0 .1.1.2.2.2.2 0 .5.1.9.1h6.2c.6 0 .9 0 1.1-.1.2-.1.3-.2.3-.3v-.1h.4v.7c0 .2 0 .3-.1.5.1.4.2.7.2 1 .1.3.1.6.1.8h-.5c-.1-.7-.3-1.2-.6-1.4-.3-.3-1-.4-2-.5h-1v6.5c0 .9 0 1.5.1 1.8 0 .3.1.6.2.8.1.2.3.3.5.4.2.1.5.1 1 .2v.4c-.4 0-.8 0-1.3-.1-.4-.1-.9-.1-1.4-.2-.5.1-1 .2-1.5.2-.3-.1-.7 0-1.1 0zm11.9-10.7c.4 0 .7.1 1.1.1.4 0 .7.1 1.1.2.5-.1 1.1-.2 1.8-.2.7-.1 1.4-.1 2.2-.1h.5c.4 0 .7 0 .8.1.1 0 .2.1.2.3 0 .1 0 .1-.1.2 0 .1-.1.2-.2.3.1.3.1.6.1.8v.7h-.4c0-.6-.2-1-.5-1.3-.3-.2-.9-.3-1.7-.3h-1.5v4.1h1.4c.7 0 1.2-.1 1.4-.2.2-.1.4-.4.4-.8h.5c0 .2 0 .4-.1.6 0 .2-.1.5-.2.7.1.3.1.5.2.8 0 .2.1.4.1.6h-.5c0-.4-.2-.7-.4-.8s-.7-.2-1.5-.2h-1.4v2.2c0 1 .1 1.6.3 1.8s.7.3 1.5.3c.9 0 1.6-.2 2.1-.5s.7-.8.8-1.6h.5c0 .4-.1.8-.2 1.1-.1.3-.2.6-.3.8 0 .1.1.2.1.2v.2c0 .2-.1.3-.3.4-.2.1-.7.1-1.5.1h-.7c-.8 0-1.5 0-2.1-.1s-1.1-.1-1.6-.2c-.4.1-.9.2-1.2.2-.4.1-.7.1-1 .1v-.4c.6 0 1-.2 1.2-.6.2-.3.3-1.2.3-2.6V8.8v-.7-.3c0-1.2-.1-2-.3-2.4-.2-.3-.6-.5-1.1-.6v-.3h.2zm13.7 10.6c0-.2.1-.4.1-.6.1-.2.1-.4.2-.5-.1-.4-.1-.7-.1-.9v-.8-.2-.2h.5c0 .9.3 1.7.8 2.2s1.2.8 2 .8c.6 0 1.2-.2 1.5-.5.4-.3.6-.8.6-1.4 0-.5-.2-.9-.5-1.2s-1-.7-1.9-1.1c-1.2-.5-1.9-1-2.4-1.4-.4-.5-.6-1.1-.6-1.7 0-.9.3-1.6 1-2.2s1.5-.8 2.6-.8c.4 0 .8 0 1.3.1s.8.1.9.1c.1 0 .2 0 .2-.1s.1-.1.1-.2h.5c0 .2-.1.3-.1.5-.1.2-.1.3-.2.5 0 .2.1.5.1.7V7.3h-.5c0-.7-.3-1.3-.7-1.7-.4-.4-.9-.6-1.6-.6-.6 0-1.1.2-1.4.5-.4.3-.5.7-.5 1.2 0 .8.9 1.6 2.6 2.4h.1c1 .4 1.8.9 2.2 1.4s.6 1.1.6 1.8c0 .9-.4 1.7-1.1 2.3-.7.6-1.7.9-2.9.9-.5 0-1.1-.1-1.7-.3-.6-.2-.9-.3-1-.3s-.2 0-.2.1c-.1 0-.1.1-.1.2l-.4-.1z"/>
            <path class="universidade" d="M2.6 26.2c.5 0 1 .1 1.5.1.5.1 1.1.2 1.7.3.6-.1 1.2-.2 1.7-.3.5-.1 1-.1 1.4-.1v.5c-.7 0-1.2.3-1.5.8S7 29.2 7 31.2v.6c0 1.8.1 3.1.2 3.9s.3 1.5.5 2c.3.7.8 1.2 1.4 1.5s1.3.5 2.1.5c1.6 0 2.7-.5 3.4-1.6.7-1 1-2.9 1-5.5v-2.2c0-1.6-.1-2.6-.4-3-.3-.4-.8-.7-1.6-.8v-.5c.4 0 .8 0 1.2.1s.9.1 1.4.2c.4-.1.8-.2 1.2-.2.4-.1.8-.1 1.3-.1v.5c-.7 0-1.2.2-1.5.6-.2.4-.4 1.4-.4 2.9V33c0 2.8-.5 4.8-1.5 6s-2.6 1.8-4.9 1.8c-1.2 0-2.3-.2-3.1-.6-.9-.4-1.5-1-2-1.7-.3-.6-.6-1.2-.7-2s-.2-1.8-.2-3.1v-3.1c0-1.6-.1-2.6-.4-3s-.8-.6-1.5-.7l.1-.4zm21.3 7.6v-2.6c0-2-.1-3.3-.4-3.8s-.9-.7-1.7-.8v-.5c.5 0 .9.1 1.3.1s.8.1 1.1.2c.4-.1.6-.2.8-.2.2 0 .3-.1.4-.1.4 0 1 .5 1.9 1.6l.2.3c1.2 1.4 2.4 2.8 3.7 4.3s2.6 2.9 4 4.4v-5.5c0-2-.1-3.3-.4-3.8-.3-.6-.8-.8-1.6-.9V26c.3 0 .7.1 1.1.1.4.1.9.1 1.4.2.6-.1 1.1-.2 1.5-.3.4 0 .7-.1 1-.1v.5h-.1c-.7 0-1.2.4-1.4 1.3-.3.8-.4 2.9-.4 6.2v6.8c-.3-.1-.5-.1-.7-.2s-.5-.1-.7-.1c-1.8-2.2-3.5-4.2-5.1-6.1-1.6-1.9-3.2-3.7-4.7-5.3v4c0 1.8 0 3.2.1 4.2.1.9.2 1.6.3 2 .1.3.3.5.6.7s.7.3 1.2.3v.5c-.4 0-.9-.1-1.4-.1-.5-.1-.9-.1-1.4-.2-.6.1-1.1.2-1.5.2-.4.1-.8.1-1.1.1v-.5c.8 0 1.3-.3 1.6-.9.3-.6.4-2.2.4-4.9v-.6zm17.5-7.6c.5 0 1 .1 1.5.1l1.8.3 1.8-.3c.5-.1 1.1-.1 1.5-.1v.5c-.8.1-1.3.3-1.6.7-.3.4-.4 1.5-.4 3.1v5.7c0 1.7.1 2.7.4 3.2.3.5.8.7 1.6.8v.5c-.5 0-1-.1-1.5-.1-.5-.1-1.1-.2-1.8-.3-.8.1-1.4.2-1.9.3s-1 .1-1.4.1v-.5c.8-.1 1.3-.3 1.6-.7s.4-1.5.4-3.1v-5.7c0-1.7-.1-2.7-.4-3.2-.3-.5-.8-.7-1.6-.8v-.5zm9.3 0c.5 0 .9.1 1.5.1.5.1 1.1.2 1.7.3.6-.1 1.2-.2 1.7-.3.5-.1 1-.1 1.4-.1v.5c-.4 0-.7.1-.9.3-.2.1-.3.3-.3.6 0 .4.3 1.4 1 3.1.6 1.7 1.6 3.9 2.7 6.5 1-2.5 1.8-4.6 2.3-6.3s.8-2.7.8-3.2c0-.3-.1-.6-.3-.7-.2-.2-.5-.3-.9-.3v-.5c.3 0 .7 0 1.2.1.4.1.9.1 1.3.2.5-.1.9-.2 1.3-.2.4-.1.8-.1 1.2-.1v.5c-.5 0-.9.2-1.3.5s-.7.7-1 1.4c-.4.8-1 2.3-1.9 4.5-.9 2.3-1.9 4.8-3 7.7h-1.1c-1.1-2.7-2.1-5.1-3-7.3-.9-2.1-1.7-3.8-2.3-5-.3-.7-.7-1.2-1-1.4-.3-.2-.7-.4-1.1-.5v-.4zm18.2 0c.5 0 1 .1 1.5.2l1.5.3c.7-.1 1.5-.2 2.5-.3.9-.1 1.9-.1 3-.1h.7c.6 0 .9 0 1.1.1s.2.2.2.4c0 .1 0 .2-.1.3 0 .1-.1.2-.2.4.1.5.1.8.1 1.1V29.7h-.6c-.1-.8-.3-1.4-.7-1.7-.4-.3-1.2-.5-2.3-.5h-2.1V33h2c1 0 1.6-.1 1.9-.3s.5-.5.6-1.1h.6c0 .3-.1.5-.1.8-.1.3-.1.6-.2 1 .1.4.2.7.2 1 .1.3.1.6.1.9H78c-.1-.5-.2-.9-.5-1.1-.3-.2-1-.3-2-.3h-1.9v3c0 1.4.1 2.2.5 2.4.3.3 1 .4 2.1.4 1.3 0 2.2-.2 2.8-.7.6-.4 1-1.1 1.1-2.1h.7c0 .5-.1 1-.2 1.4s-.2.8-.4 1.1c.1.1.1.2.1.3v.3c0 .3-.1.4-.4.5s-.9.1-2 .1H77c-1.1 0-2.1 0-2.9-.1s-1.5-.2-2.1-.3c-.6.1-1.2.2-1.7.3s-1 .1-1.4.1v-.5c.8-.1 1.3-.3 1.6-.8.3-.4.4-1.6.4-3.5V32v-.9-.5c0-1.7-.1-2.7-.4-3.2s-.8-.7-1.5-.8l-.1-.4zm24.2 7.2c1.3 2.6 2.3 4.4 3.2 5.3.8 1 1.7 1.4 2.6 1.4h.1v.5c-.3 0-.5.1-.7.1h-.5c-.9 0-1.7-.1-2.3-.2-.6-.2-1.1-.4-1.5-.8-.7-.6-1.4-1.7-2.2-3.3-.3-.6-.5-1-.7-1.3-.3-.6-1-.9-1.9-.9h-.7v2c0 1.7.1 2.8.4 3.3.3.4.8.7 1.6.7v.5c-.5 0-1-.1-1.5-.1-.5-.1-1.1-.2-1.8-.3-.8.1-1.4.2-1.9.3s-1 .1-1.4.1v-.5c.8 0 1.3-.3 1.6-.7.3-.4.4-1.5.4-3.1v-5.6c0-1.7-.1-2.8-.4-3.3s-.8-.7-1.6-.8v-.5c.5 0 1 .1 1.5.1.5.1 1 .1 1.5.2.6-.1 1.2-.2 1.9-.3.6-.1 1.2-.1 1.9-.1 1.7 0 3 .3 3.9.9s1.3 1.6 1.3 2.8c0 .8-.2 1.5-.7 2.2-.5.6-1.2 1.1-2.1 1.4zm-4.5 0c.3 0 .6.1.8.1h.6c.9 0 1.6-.3 2.2-.8.5-.5.8-1.3.8-2.3 0-1.1-.3-2-.9-2.6s-1.4-.9-2.4-.9c-.2 0-.5 0-.9.1h-.1v3l-.1 3.4zm13.3 7.1c.1-.3.1-.6.2-.8.1-.3.2-.5.3-.7-.1-.5-.1-.9-.2-1.3 0-.4-.1-.7-.1-1.1v-.2-.2h.7c.1 1.3.4 2.3 1.1 3s1.6 1.1 2.7 1.1c.9 0 1.6-.2 2.1-.7s.8-1.1.8-1.8-.2-1.2-.6-1.7-1.3-1-2.6-1.5c-1.6-.7-2.6-1.3-3.2-2-.6-.6-.9-1.4-.9-2.4 0-1.2.5-2.2 1.4-3s2.1-1.1 3.6-1.1c.5 0 1.1.1 1.8.2s1.1.2 1.2.2.2 0 .3-.1l.2-.2h.6c-.1.2-.1.4-.2.7-.1.2-.1.4-.2.6.1.3.1.6.1 1V30h-.7c-.1-1-.4-1.8-.9-2.3-.5-.6-1.3-.8-2.2-.8-.8 0-1.4.2-1.9.6s-.7 1-.7 1.7c0 1.1 1.2 2.2 3.6 3.2h.1c1.4.6 2.4 1.2 3 1.9.6.6.9 1.4.9 2.4 0 1.3-.5 2.3-1.5 3.1s-2.3 1.2-3.9 1.2c-.7 0-1.5-.1-2.3-.4-.8-.2-1.2-.4-1.3-.4-.1 0-.2 0-.3.1-.1.1-.2.2-.2.3l-.8-.1zm14-14.3c.5 0 1 .1 1.5.1l1.8.3 1.8-.3c.5-.1 1.1-.1 1.5-.1v.5c-.8.1-1.3.3-1.6.7-.3.4-.4 1.5-.4 3.1v5.7c0 1.7.1 2.7.4 3.2s.8.7 1.6.8v.5c-.5 0-1-.1-1.5-.1-.5-.1-1.1-.2-1.8-.3-.8.1-1.4.2-1.9.3s-1 .1-1.4.1v-.5c.8-.1 1.3-.3 1.6-.7.3-.4.4-1.5.4-3.1v-5.7c0-1.7-.1-2.7-.4-3.2s-.8-.7-1.6-.8v-.5zm13.3 14c-.6.1-1.2.2-1.7.3s-1.1.1-1.6.1v-.5c.8 0 1.3-.3 1.6-.7.3-.4.4-1.5.4-3.1v-5.8c0-1.6-.1-2.7-.4-3.1s-.8-.7-1.6-.7v-.5c.5 0 1 .1 1.5.1.5.1 1.1.2 1.7.3.7-.2 1.5-.3 2.1-.3.7-.1 1.3-.1 1.9-.1 2.7 0 4.8.7 6.4 2 1.5 1.3 2.3 3.1 2.3 5.4 0 2.2-.8 4-2.3 5.3s-3.6 2-6.3 2c-.6 0-1.2 0-1.8-.1-.5-.2-1.3-.4-2.2-.6zm1.4-5.4v3.3c0 .5.1.8.1 1 .1.3.4.5.7.7.4.1.9.2 1.6.2 1.8 0 3.2-.6 4.2-1.7s1.5-2.7 1.5-4.7c0-2.2-.5-3.9-1.6-5.1s-2.6-1.8-4.7-1.8h-1c-.3 0-.6.1-.8.1 0 .6-.1 1.3-.1 2.1v5.9h.1zm20.4-8.9h1.5l2.8 7.2c.2.4.4 1 .7 1.8 1.3 3.5 2.4 5.2 3.4 5.2v.5c-.6 0-1.6-.2-2.9-.3h-.3c-.7.1-1.2.2-1.7.2-.5.1-1 .1-1.4.1v-.5c.5 0 .8-.1 1-.3.2-.1.3-.4.3-.6 0-.2-.1-.6-.2-1.1s-.4-1.2-.6-2l-.4-1.1h-5l-.4.9c-.3.7-.5 1.4-.7 2s-.3 1-.3 1.2c0 .3.1.5.3.7s.5.2 1 .2v.5c-.4 0-.7-.1-1.1-.1-.4-.1-.8-.1-1.3-.3-.5.1-.9.2-1.4.3-.4.1-.8.1-1.2.1V40h.1c1.1 0 2.4-1.8 3.9-5.4.3-.7.5-1.2.7-1.6l3.2-7.1zm0 2.9c-.4.9-.8 1.8-1.1 2.7-.4.9-.7 1.9-1.1 2.8h4.3c-.4-1-.7-2-1-2.9-.4-.9-.7-1.8-1.1-2.6zm13.8 11.4c-.6.1-1.2.2-1.7.3s-1.1.1-1.6.1v-.5c.8 0 1.3-.3 1.6-.7s.4-1.5.4-3.1v-5.8c0-1.6-.1-2.7-.4-3.1-.3-.4-.8-.7-1.6-.7v-.5c.5 0 1 .1 1.5.1.5.1 1.1.2 1.7.3.7-.2 1.5-.3 2.1-.3.7-.1 1.3-.1 1.9-.1 2.7 0 4.8.7 6.4 2 1.5 1.3 2.3 3.1 2.3 5.4 0 2.2-.8 4-2.3 5.3s-3.6 2-6.3 2c-.6 0-1.2 0-1.8-.1-.5-.2-1.2-.4-2.2-.6zm1.4-5.4v3.3c0 .5.1.8.1 1 .1.3.4.5.7.7.4.1.9.2 1.6.2 1.8 0 3.2-.6 4.2-1.7s1.5-2.7 1.5-4.7c0-2.2-.5-3.9-1.6-5.1s-2.6-1.8-4.7-1.8h-1c-.3 0-.6.1-.8.1 0 .6-.1 1.3-.1 2.1v5.9h.1zm14.8-8.6c.5 0 1 .1 1.5.2l1.5.3c.7-.1 1.5-.2 2.5-.3.9-.1 1.9-.1 3-.1h.7c.6 0 .9 0 1.1.1.2.1.2.2.2.4 0 .1 0 .2-.1.3 0 .1-.1.2-.2.4.1.5.1.8.1 1.1V29.7h-.6c-.1-.8-.3-1.4-.7-1.7-.4-.3-1.2-.5-2.3-.5h-2.1V33h2c1 0 1.6-.1 1.9-.3.3-.2.5-.5.6-1.1h.6c0 .3-.1.5-.1.8-.1.3-.1.6-.2 1 .1.4.2.7.2 1 .1.3.1.6.1.9h-.6c-.1-.5-.2-.9-.5-1.1-.3-.2-1-.3-2-.3h-1.9v3c0 1.4.2 2.2.5 2.4.3.3 1 .4 2.1.4 1.3 0 2.2-.2 2.8-.7.6-.4 1-1.1 1.1-2.1h.7c0 .5-.1 1-.2 1.4-.1.4-.2.8-.4 1.1.1.1.1.2.1.3v.3c0 .3-.1.4-.4.5-.3.1-.9.1-2 .1h-.9c-1.1 0-2.1 0-2.9-.1-.8-.1-1.5-.2-2.1-.3-.6.1-1.2.2-1.7.3s-1 .1-1.4.1v-.5c.8-.1 1.3-.3 1.6-.8.3-.4.4-1.6.4-3.5V32v-.9-.5c0-1.7-.1-2.7-.4-3.2s-.8-.7-1.5-.8v-.4h-.1zM27.2 48.1l.9.3c-.2.6-.3 1.1-.4 1.5s-.3.8-.4 1.2c.1.9.2 1.8.2 2.6s.1 1.6.1 2.4h-1.3c-.2-2.3-.9-4-2.3-5.3-1.4-1.2-3.2-1.9-5.5-1.9-3.1 0-5.5 1.1-7.3 3.4-1.8 2.3-2.7 5.3-2.7 9.2 0 3.8 1 6.9 2.9 9.2 1.9 2.3 4.5 3.5 7.6 3.5 2.3 0 4.1-.5 5.5-1.5s2.2-2.5 2.4-4.4h1.4c-.1.6-.2 1.3-.3 1.9-.1.6-.2 1.3-.4 1.9.1.4.1.8.2 1 0 .2.1.4.1.6-1.2.6-2.6 1.1-4.3 1.5-1.6.3-3.3.5-5.2.5-4.9 0-8.8-1.2-11.7-3.7s-4.3-5.8-4.3-10.1 1.4-7.7 4.3-10.4c2.9-2.6 6.8-3.9 11.6-3.9 1.7 0 3.4.2 5.1.5 1.8.3 2.7.5 2.8.5.3 0 .5 0 .7-.1 0-.1.2-.3.3-.4zm37.1 13.5c0 4.1-1.4 7.4-4.1 10.1-2.7 2.7-6.2 4-10.4 4s-7.7-1.3-10.4-4-4.1-6-4.1-10.1c0-4 1.4-7.4 4.1-10s6.2-4 10.4-4 7.7 1.3 10.4 4c2.7 2.6 4.1 6 4.1 10zM49.8 74.4c2.6 0 4.7-1.2 6.2-3.5 1.6-2.3 2.3-5.4 2.3-9.3s-.8-7-2.3-9.3c-1.6-2.3-3.6-3.4-6.2-3.4s-4.7 1.1-6.2 3.4-2.3 5.4-2.3 9.3.8 7 2.3 9.3 3.6 3.5 6.2 3.5zm19.4-26.3c.9 0 1.8.1 2.9.3 1 .1 2.2.3 3.4.5 1.2-.2 2.3-.4 3.3-.5s2-.2 2.9-.3v.9c-1.4.1-2.4.6-2.9 1.4-.5.8-.8 2.8-.8 5.8v10.6c0 3.2.3 5.2.8 6 .5.9 1.5 1.3 2.9 1.4v.9c-.9 0-1.8-.1-2.9-.3-1-.1-2.1-.3-3.3-.5-1.5.2-2.7.4-3.6.5-1 .1-1.8.2-2.6.2v-.9c1.4-.1 2.4-.6 2.9-1.4s.8-2.8.8-5.9V56.2c0-3.2-.3-5.2-.8-6-.5-.9-1.5-1.4-2.9-1.5v-.6h-.1zM88 75.2v-.9c1-.2 1.7-.4 2.1-.7.4-.3.8-.9 1-1.7.3-.9.5-3.3.8-7.3l.1-.6c.2-2.1.3-4.1.4-5.9.1-1.8.1-3.4.1-4.7 0-1.9-.2-3-.7-3.5s-1.5-.8-3-.9v-.9c.7 0 1.4.1 2.2.2.8.1 1.7.2 2.8.4.8-.2 1.4-.4 1.7-.4.3-.1.6-.1.8-.1.7 0 1.3.7 2 2.2.1.2.1.3.2.4 2.1 4.5 3.9 8 5.2 10.6 1.3 2.6 2.5 5 3.7 7 2.2-4.6 4.5-9.6 6.9-15 .6-1.4 1-2.3 1.2-2.7.1-.1.2-.3.3-.6.5-1.2 1.1-1.9 1.7-1.9.3 0 .9.1 2 .4l.3.1c.9-.2 1.8-.3 2.6-.4.8-.1 1.4-.2 1.9-.2v.9c-1.2.1-1.9.4-2.3.8-.4.5-.5 1.9-.5 4.2v1.3c0 .4 0 .9.1 1.3L122 67c.1 3.2.4 5.2.9 6.1.5.8 1.3 1.3 2.6 1.3v.9c-.8 0-1.6-.1-2.5-.2s-1.9-.3-2.9-.5c-1.1.2-2.1.4-3 .5s-1.8.2-2.6.2v-.9c1.1 0 1.8-.4 2.2-1 .4-.6.6-1.9.6-3.8v-1.4c0-.6 0-1.5-.1-2.4L117 59c-.1-1.4-.1-2.5-.2-3.3 0-.8-.1-1.5-.2-2.1-1.7 3.5-3.4 7.1-5 10.7s-3.2 7.3-4.7 11h-1.5c-1.5-3.3-3.1-6.6-4.9-10.2-1.7-3.5-3.6-7.2-5.7-11.2-.2 3.6-.4 6.8-.5 9.5s-.2 4.7-.2 6c0 1.9.2 3.2.7 3.9.5.7 1.4 1 2.8 1.1v.9c-.7 0-1.5-.1-2.3-.2s-1.6-.2-2.5-.4c-.9.2-1.8.3-2.6.4-.8 0-1.5.1-2.2.1zm47.1-10.9v-7.8c0-3.2-.3-5.2-.8-6.1-.5-.9-1.5-1.4-2.9-1.5V48c.8 0 1.6.1 2.5.2.9.1 2 .3 3.4.5 1.3-.3 2.6-.5 3.8-.7s2.4-.2 3.5-.2c2.8 0 4.9.5 6.4 1.6s2.2 2.6 2.2 4.5c0 1.6-.5 2.9-1.6 4s-2.6 1.8-4.6 2.3v.3c2.7.2 4.8 1 6.2 2.2s2.1 2.9 2.1 5c0 2.4-.9 4.3-2.8 5.7-1.8 1.3-4.4 2-7.8 2-1.2 0-2.4-.1-3.6-.2-1.2-.1-2.5-.4-3.7-.7-1.4.2-2.6.4-3.5.5s-1.8.2-2.5.2v-.9c1.4-.1 2.4-.5 2.9-1.4.5-.8.8-2.8.8-5.9v-2.7zm5-3v5.4c0 3.3.3 5.3.8 6.1.5.7 1.5 1.1 3 1.1 1.7 0 3.1-.5 4.1-1.6s1.5-2.5 1.5-4.4c0-2.2-.7-3.9-2-5s-3.3-1.6-6-1.6h-1.4zm.1-1.4h1.8c2 0 3.5-.4 4.5-1.3s1.4-2.2 1.4-4.1c0-1.6-.5-2.9-1.5-3.9s-2.4-1.5-4.1-1.5h-1.1c-.3 0-.6.1-.9.2 0 .4-.1.9-.1 1.4v9.2zm37.2 1.7c2.4 4.9 4.4 8.2 6 10s3.2 2.7 4.9 2.7h.3v.9c-.5.1-.9.1-1.2.1h-1c-1.7 0-3.2-.2-4.2-.5-1.1-.3-2-.8-2.8-1.5-1.3-1.1-2.7-3.2-4.1-6.2-.5-1.1-1-1.9-1.3-2.4-.6-1.1-1.8-1.6-3.6-1.7h-1.3v3.7c0 3.3.3 5.3.8 6.1.5.8 1.5 1.3 2.9 1.4v.9c-.9 0-1.8-.1-2.9-.2-1-.1-2.1-.3-3.3-.5-1.5.2-2.7.4-3.6.5-.9.1-1.8.2-2.6.2v-.9c1.4-.1 2.4-.5 2.9-1.3s.8-2.8.8-5.8V56.5c0-3.3-.3-5.3-.8-6.2s-1.6-1.3-3.1-1.4V48c.9 0 1.9.1 2.8.2.9.1 1.9.3 2.9.5 1.2-.3 2.3-.4 3.5-.6 1.2-.1 2.3-.2 3.5-.2 3.3 0 5.7.6 7.4 1.8s2.5 2.9 2.5 5.2c0 1.5-.5 2.9-1.4 4.1-1.1 1.2-2.4 2.1-4 2.6zm-8.5.1c.6.1 1.1.1 1.5.2h1.1c1.7 0 3.1-.5 4.1-1.5s1.5-2.5 1.5-4.3c0-2.1-.5-3.7-1.6-4.9s-2.6-1.7-4.6-1.7c-.3 0-.9 0-1.6.1h-.2v.2c0 2.5-.1 4.3-.1 5.5l-.1 6.4zm35.4-14.1h2.9l5.3 13.5c.3.8.8 1.9 1.3 3.4 2.5 6.5 4.6 9.8 6.4 9.8v.9c-1.1-.1-2.9-.3-5.4-.6l-.5-.1c-1.2.2-2.3.3-3.2.5-.9.1-1.8.2-2.6.2v-.9c.9-.1 1.5-.2 2-.5.4-.3.6-.7.6-1.2 0-.4-.1-1-.4-2-.3-1-.7-2.2-1.2-3.7l-.7-2.1h-9.2l-.7 1.8c-.5 1.4-1 2.6-1.3 3.7s-.5 1.8-.5 2.3c0 .6.2 1 .5 1.2.4.3 1 .4 1.8.4v.9c-.7 0-1.4-.1-2.1-.2-.8-.1-1.6-.3-2.5-.5-.9.2-1.8.4-2.5.5-.8.1-1.5.2-2.2.2v-.9h.2c2.1 0 4.5-3.4 7.2-10.2.5-1.3.9-2.3 1.2-3l5.6-13.4zm0 5.3l-2.1 5.1c-.7 1.7-1.4 3.5-2 5.2H208.1c-.7-2-1.3-3.8-2-5.5-.6-1.5-1.2-3.2-1.8-4.8zm11.8-24.7c-1.5-1.3-3.6-1.9-6.3-1.9-.6 0-1.2 0-1.9.1-.6.1-1.3.2-1.9.3h-.2c-.6-.1-1.2-.2-1.7-.3-.5-.1-1-.1-1.5-.1v.5c.7.1 1.3.3 1.5.8.3.4.4 1.5.4 3.2v6.6c-.1 1.1-.2 1.8-.4 2.2-.3.4-.8.7-1.5.7v.5c.2 0 .5 0 .7-.1.3 0 .5-.1.8-.1.5-.1 1.1-.2 1.7-.3.1 0 .3.1.5.1.7.1 1.4.3 1.9.3.6.1 1.2.1 1.8.1 2.6 0 4.7-.6 6.2-1.9 1.5-1.3 2.3-3 2.3-5.3-.1-2.3-.9-4.1-2.4-5.4zm-2.3 10.2c-1 1.1-2.4 1.6-4.1 1.6-.7 0-1.2-.1-1.6-.2-.4-.1-.6-.4-.7-.6-.1-.2-.1-.5-.1-1v-4.5h1.4c1 0 1.7.1 2 .3s.5.6.5 1.1h.6c0-.3-.1-.5-.1-.8-.1-.3-.1-.6-.2-1 .1-.3.2-.7.2-1 .1-.3.1-.6.1-.8h-.6c-.1.5-.2.9-.6 1.1-.3.2-1 .3-1.9.3h-1.5v-.7-2.9c0-.8.1-1.5.1-2 .2-.1.5-.1.8-.1h1c2 0 3.5.6 4.6 1.8 1.1 1.2 1.6 2.9 1.6 5 0 1.8-.5 3.3-1.5 4.4z"/>
          </svg>
        </router-link>
      </div>
      <div class="xxlarge-5 small-4 xsmall-6 columns relative text-right">
        <button class="show-rooms" v-on:click="showRoomClick">
            Salas
          <svg class="arrow-down" viewBox="0 0 20 10">
            <path d="M2.1.3C1.8 0 1.2 0 .8.3c-.3.3-.3.9 0 1.3l8.7 8.2c.2.2.4.2.6.2.3 0 .5-.1.6-.2l8.5-8.1c.4-.4.4-.9 0-1.3-.3-.3-.9-.4-1.3 0l-7.8 7.5-8-7.6z"/>
          </svg>
        </button>
        <ul class="room-list">
          <li><router-link v-bind:to="'/sala/quarto-22'" class="quarto-22"><span>Quarto 22</span></router-link></li>
          <li><router-link v-bind:to="'/sala/laboratorio-de-curadoria'" class="lab-curadoria"><span>Laboratório de Curadoria</span></router-link></li>
        </ul>
      </div>
    </div>
    <div class="row xxlarge-10 expanded columns year-row">
      <ul class="flex-container align-center">
        <li v-for="date in allDates" :data-target="['date-' + date]" v-on:click="clickEvent"> {{date}}</li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { TweenMax } from 'greensock';

export default {
  name: 'fixed-header',
  data () {
    return {
      isVisible: false,
      slug: '',
      menuIsOpen: false
    }
  },
  mounted () {
    this.slug = this.$route.params.slug;
  },
  methods: {
    showRoomClick: function(event) {
      if(!this.menuIsOpen) {
        this.menuIsOpen = true;
        TweenMax.staggerTo(event.target.nextElementSibling.children, .5, {
          y: 0,
          autoAlpha: 1,
          ease:Power4.easeOut
        }, .25);
      }
      else {
        this.menuIsOpen = false;
        TweenMax.staggerTo(event.target.nextElementSibling.children, .5, {
          y: 5,
          autoAlpha: 0,
          ease:Power4.easeOut,
          clearProps: "all"
        }, -.25);
      }
    },
    clickEvent : function(event) {
      var targetElement = document.getElementsByClassName(event.target.dataset.target);

      if(targetElement[0])
        window.scrollTo({
          top: targetElement[0].offsetTop,
          behavior: "smooth"
        });
    },
    handleScroll: function() {
      if(window.pageYOffset > 100 ) {
        if(!this.isVisible) {
          this.isVisible = true;
          TweenMax.to("#fixed-header", 1, {
            y: "0%",
            ease:Power4.easeOut,
            onComplete: function() {
            }
          });
        }
      }
      else {
        if(this.isVisible) {
          this.isVisible = false;
          TweenMax.to("#fixed-header", 1, {
            y: "-110%",
            ease:Power4.easeOut,
            onComplete: function() {
            }
          });
        }
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    allDates() {
      return this.$store.getters.getAllDates(this.slug);
    }
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">

#fixed-header {
  position: fixed;
  width: 100%;
  // height: 40px;
  top: 0;

  -webkit-transform: translateY(-110%);
          transform: translateY(-110%);

  z-index: 100;

  .nav-row {
    padding: 20px 80px;
    background-color: #ffffff;

    .main-logo {
      position: relative;
      width: 111px;
      height: 38px;
    }

    .back-link {
      display: inline-flex;
      align-items: center;

      transition: color .25s ease-in-out;

      &:after {
        background-color: #000;
        height: 0;
      }

      &:hover {
        color: #fff;
        &:after {
          height: 100%;
        }
      }
    }

    .show-rooms {
      display: none;
      font-family: 'TT Norms';
      @include responsive-font-size(13px);
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #000000;
      align-items: center;
      padding: 0;
      margin: 0;
      border: none;
      -webkit-appearence: none;
      outline: none;
      background-color: transparent;

      .arrow-down {
        width: 11px;
        height: 8px;
        margin-left: 10px;

        transition: transform .25s ease-in-out;
      }

      &:hover {
        .arrow-down {
          transform: translateY(5px);
        }
      }
    }

    ul {
      text-align: right;

      li {
        display: inline-block;
        margin: 0 20px;

        &:last-of-type { margin-right: 0px; }
      }
    }
  }

  .year-row {
    background-color: #000000;

    ul {
      li {
        line-height: 40px;
        display: inline-block;
        color: #ffffff;
        margin: 0 20px;

        text-align: center;
        font-family: 'TT Norms';
        @include responsive-font-size(13px);
        text-transform: uppercase;
        cursor: pointer;
      }
    }
  }
}

.category,
.exhibition {
  #fixed-header {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    .year-row { display: none; }
  }
}

body.mobile {
  #fixed-header {
    .nav-row {
      .back-link {
        &:hover {
          color: #000;
          &:after {
            height: 0;
          }
        }
      }
      .show-rooms {
        &:hover {
          .arrow-down {
            transform: translateY(0);
          }
        }
      }
    }
  }
}

@include max-screen(1080px) {
  #fixed-header {
   .nav-row {
      padding: 20px 60px;

      .main-logo {
        width: 91px;
        height: 31px;
      }

      .show-rooms { display: inline-flex; }

      .room-list {
        display: inline-block;
        position: absolute;
        right: 0;
        top: 35px;
        white-space: nowrap;

        li {
          display: block;
          margin: 0;
          margin-bottom: 10px;

          opacity: 0;
          visibility: hidden;

          transform: translateY(5px);

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

@include max-screen($small) {
  #fixed-header {
    .nav-row {
      padding: 20px 30px;
    }
  }
}

@include max-screen($xsmall) {
  #fixed-header {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    .nav-row {
      padding: 20px;

      .hide-mq { display: none; }
      .text-center { text-align: left; }
    }

    .year-row { display: none; }
  }
}

@include max-screen($xxsmall) {
  #fixed-header {
    .nav-row {
      .main-logo {
        width: 81px;
        height: 28px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/fixedHeader.vue